import { useCallback, useRef, useLayoutEffect } from 'react';

/**
 * Allows you to merge refs with a callback ref
 *
 * @param refs to merge
 * @returns CallbackRef
 */
function useRefMerger() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    return useCallback(function (current) {
        refs.forEach(function (ref) {
            if (!ref)
                return;
            if (typeof ref === 'function') {
                ref(current);
            }
            else {
                ref.current = current;
            }
        });
        // the spread is a new array, we only want it to change when refs change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

/**
 * Allows us to reuse the `ref` from `forwardRef` within the component
 * See https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
 */
function useCombinedRef() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    var targetRef = useRef(null);
    var merge = useRefMerger.apply(void 0, refs);
    useLayoutEffect(function () { return merge(targetRef.current); }, [merge]);
    return targetRef;
}

export { useCombinedRef };
